import React, {useState} from 'react'
import {toast} from 'react-toastify'
import {SavDetailResponse, SavReferentiels} from '../../../../components/sav/Models'
import {envoyerSavRetour, organiserSavRetour, savErreur} from '../../../../components/sav/requests'
import {ouvrirDocument} from '../components/SavDocuments'

type Props = {
  detail: SavDetailResponse
  referentiels: SavReferentiels
  onMaj: (detail: SavDetailResponse) => void
  onEnvoye: (detail: SavDetailResponse) => void
}

// Écran 4, carte « Organiser le retour » : bon de retour, transporteur, site de réception, envoi au client
const SavOrganiserRetour = ({detail, referentiels, onMaj, onEnvoye}: Props) => {
  const {dossier} = detail
  const retour = dossier.retours.find((r) => !r.dateEnvoiEtiquette && !r.dateReception)
  const bon = retour
    ? [...dossier.documents]
        .reverse()
        .find(
          (d) => d.type === 'BON_RETOUR' && d.nomFichier.includes(retour.numeroBonRetour ?? '§')
        )
    : undefined
  const [transporteur, setTransporteur] = useState<string>(
    retour?.transporteur?.id ? String(retour.transporteur.id) : ''
  )
  const [site, setSite] = useState<string>(
    retour?.siteReception?.id ? String(retour.siteReception.id) : ''
  )
  const [numeroSuivi, setNumeroSuivi] = useState(retour?.numeroSuivi ?? '')
  const [commentaire, setCommentaire] = useState('')
  const [envoi, setEnvoi] = useState(false)

  const preparer = () => {
    setEnvoi(true)
    organiserSavRetour(dossier.id, {
      transporteur: transporteur ? Number(transporteur) : null,
      siteReception: site ? Number(site) : null,
      numeroSuivi,
    })
      .then((d) => {
        onMaj(d)
        toast.success('Bon de retour généré')
      })
      .catch((e) => toast.error(savErreur(e)))
      .finally(() => setEnvoi(false))
  }

  const envoyer = () => {
    if (!retour) return
    setEnvoi(true)
    envoyerSavRetour(dossier.id, retour.id, commentaire || undefined)
      .then((d) => {
        toast.success('Dossier en Retour attendu')
        onEnvoye(d)
      })
      .catch((e) => toast.error(savErreur(e)))
      .finally(() => setEnvoi(false))
  }

  const modifie =
    !!retour &&
    (String(retour.transporteur?.id ?? '') !== transporteur ||
      (!!site && String(retour.siteReception?.id ?? '') !== site) ||
      (retour.numeroSuivi ?? '') !== numeroSuivi)

  return (
    <div className='border rounded p-5'>
      <h4 className='mb-5'>Organiser le retour</h4>
      <div className='row g-4'>
        <div className='col-md-6'>
          <label className='form-label'>Bon de retour</label>
          <div className='form-control form-control-solid fw-bold'>
            {retour?.numeroBonRetour ?? 'Généré automatiquement'}
          </div>
        </div>
        <div className='col-md-6'>
          <label className='form-label'>Transporteur</label>
          <select
            className='form-select'
            value={transporteur}
            onChange={(e) => setTransporteur(e.target.value)}
          >
            <option value=''>Dépôt du client au comptoir</option>
            {referentiels.transporteurs.map((t) => (
              <option key={t.id} value={t.id}>
                {t.libelle}
              </option>
            ))}
          </select>
        </div>
        <div className='col-md-6'>
          <label className='form-label'>Site de réception</label>
          <select className='form-select' value={site} onChange={(e) => setSite(e.target.value)}>
            <option value=''>Site SAV du centre (par défaut)</option>
            {referentiels.sites.map((s) => (
              <option key={s.id} value={s.id}>
                {s.nom}
              </option>
            ))}
          </select>
        </div>
        <div className='col-md-6'>
          <label className='form-label'>N° de suivi (facultatif)</label>
          <input
            className='form-control form-control-solid'
            value={numeroSuivi}
            onChange={(e) => setNumeroSuivi(e.target.value)}
          />
        </div>
      </div>

      <div className='alert alert-info mt-5'>
        Au passage en Retour attendu, le message « Bon de retour et consignes » vous est proposé,
        avec le bon de retour en pièce jointe. SMS : prévu en V2.
      </div>
      <label className='form-label'>Commentaire (facultatif)</label>
      <input
        className='form-control form-control-solid mb-5'
        value={commentaire}
        onChange={(e) => setCommentaire(e.target.value)}
      />

      <div className='d-flex flex-wrap gap-3'>
        {(!retour || modifie) && (
          <button className='btn btn-light-primary' disabled={envoi} onClick={preparer}>
            {retour ? 'Mettre à jour le bon' : 'Générer le bon de retour'}
          </button>
        )}
        {bon && !modifie && (
          <button className='btn btn-light' onClick={() => ouvrirDocument(bon)}>
            <i className='bi bi-printer'></i> Imprimer le bon
          </button>
        )}
        {retour && !modifie && (
          <button className='btn btn-success' disabled={envoi} onClick={envoyer}>
            Envoyer et passer en Retour attendu
          </button>
        )}
      </div>
    </div>
  )
}

export default SavOrganiserRetour
